const version = {
  number: 'v23'
}

export default version;

